import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function InfoTooltip({ text }: { text: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          // inline-flex e align-middle: cosi' l'icona puo' seguire il testo dentro
          // una riga invece di essere un blocco a se'. Dentro un contenitore flex
          // il display viene comunque riportato a flex, quindi gli usi esistenti
          // non cambiano.
          className="inline-flex align-middle text-gray-400 hover:text-gray-600 flex-shrink-0"
          aria-label={text}
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs text-sm font-normal">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}

export default InfoTooltip;
